export const GET_SETTING_GLOBAL = 'GET_SETTING_GLOBAL';

export const GET_SETTING_GLOBAL_SUCCESS = 'GET_SETTING_GLOBAL_SUCCESS';

export const GET_SETTING_GLOBAL_FAILED = 'GET_SETTING_GLOBAL_FAILED';